module.exports = __webpack_public_path__ + "static/media/mdsalert03.e81468b0.wav";